import {useState} from "react";
import useResizeObserver from "use-resize-observer";
import {useMedia} from "@hooks/ui/useMedia";

export function useFullScreenMode(){
    const{isDesktop} = useMedia()

    const[height,setHeight] = useState(0)
    const {ref} = useResizeObserver({
        onResize: ({height}) => {
            setHeight(height)

        }
    });

    const [fullScreenMode, setFullScreenMode] = useState(false)


    return {
        fullScreenMode,
        setFullScreenMode,
        innerRef:ref,
        maxHeightScreen:`calc(95vh - ${(isDesktop ? 95 : 64) + (height ?? 0)}px)`,
    }
}